import { getRedirectPath } from '$services/session/redirectPath/redirectPath.service'
import { routeProvider } from '$utils/routeProvider'
import { userGroupService } from '$utils/services/userGroupService'
import { routerHistory } from '$utils/services/routerHistoryService'
import history from '$utils/history'

const reservationConfirmPath = 'confirmar-reserva'
const caretakerRecommendationPath = 'recomendacion-cuidador'
const caretakerProPaymentPath = 'pro/plan'

const isAdminOrCustomer = () => userGroupService.isAdmin() || userGroupService.isCustomer()

const isCaretakerOrCustomer = () => userGroupService.isCustomer() || userGroupService.isCaretaker()

const urlContainsConfirmServicesDurationPath = redirectPath =>
  redirectPath.indexOf(routeProvider.confirmServicesDuration) > -1

const urlContainsTimeExpiredServicePath = redirectPath => redirectPath.indexOf(routeProvider.timeExpired) > -1

const urlContainsReservationConfirm = redirectPath => redirectPath.indexOf(reservationConfirmPath) > -1

const urlContainsCaretakerRecommendation = redirectPath => redirectPath.indexOf(caretakerRecommendationPath) > -1

const urlContainsCaretakerProPayment = redirectPath => redirectPath.indexOf(caretakerProPaymentPath) > -1

const urlContainsRecruitingForm = redirectPath => redirectPath.indexOf(routeProvider.recruitingForm) > -1

const urlContainsCaretakerCard = redirectPath => redirectPath.indexOf(routeProvider.caretakerCard('')) > -1

export const redirectUserPath = profile => {
  const redirectPath = getRedirectPath()

  if (isCaretakerOrCustomer() && urlContainsRecruitingForm(redirectPath)) {
    return redirectPath
  }
  if (isCaretakerOrCustomer() && urlContainsConfirmServicesDurationPath(redirectPath)) {
    return redirectPath
  }
  if (isCaretakerOrCustomer() && urlContainsTimeExpiredServicePath(redirectPath)) {
    return redirectPath
  }
  if (isCaretakerOrCustomer() && urlContainsReservationConfirm(redirectPath)) {
    return redirectPath
  }
  if (isCaretakerOrCustomer() && urlContainsCaretakerRecommendation(redirectPath)) {
    return redirectPath
  }
  if (isCaretakerOrCustomer() && urlContainsCaretakerProPayment(redirectPath)) {
    return redirectPath
  }
  if (isCaretakerOrCustomer() && urlContainsCaretakerCard(redirectPath)) {
    return redirectPath
  }
  if (userGroupService.isCaretaker()) {
    routerHistory.setPreviousPath(history.location.pathname)
    return routeProvider.offersForCaretaker
  }
  if (userGroupService.isRecruiter()) {
    return routeProvider.myRecruitingService
  }
  if (userGroupService.isNormalCustomer()) {
    return routeProvider.myUserArea
  }
  if (isAdminOrCustomer()) {
    return routeProvider.myServices
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/infrastructure/redirectUserPath/redirectUserPath.ts